import BaseViewController from "./base-view-controller";
import { formatPhone } from "../utils/prepare-submit";

class EmergencyContactController extends BaseViewController {
  prepareSubmit(values) {
    return formatPhone(values);
  }
}

export default EmergencyContactController;
